<div class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-bell"></i></span>{{ "BellNotifications.Header" | translate }}
  </h1>
  <p-card>
    <ng-template pTemplate="title">
        <span>{{ title }}</span>
    </ng-template>
    <p-card>
      <p-accordion>
        <div class="mt-2" [innerHTML]="content">
        </div>

        <div *ngIf="isFileDialogLoading" class="flex justify-content-center">
          <p-progressSpinner></p-progressSpinner>
        </div>

        <div class="flex flex-wrap justify-content-start" *ngIf="!isFileDialogLoading">
          <div *ngFor="let file of fileList">
            <div class="file-block">
              <a [href]="transformToSafeUrl(file.fileDataUrl)"
                  [download]="file.fileName">
                  <span class="download-mask pi pi-download"></span>
              </a>

              <img *ngIf="isImageTypeFile(file.fileType!); else downloadableFileIconTemplate"
                [alt]="file.fileName"
                [src]="transformToSafeUrl(file.fileDataUrl)"/>

              <ng-template #downloadableFileIconTemplate>
                <span class="file-icon pi pi-file-o"></span>
              </ng-template>
            </div>

            <div class="file-name-block">
              <p>{{ file.fileName }}</p>
            </div>
          </div>
        </div>
      </p-accordion>
    </p-card>
  </p-card>
</div>
